import { EVisibility } from "./form";

export enum NetworkCode {
    Unknown = -1,
    DCC,
    HVDC,
    RfG,
}

export interface IParameter {
    guid: string;
    name: string;
    description: string;
    networkCode: NetworkCode;
    visibility: EVisibility;
    published: boolean;
    timeCreated: string;
    timePublished: string;
    deadline: string;
    hidden: boolean;
    year: string;
    answer1text: string;
    answer2text: string;
    answer3text: string;
    answer4text: string;
    answer5text: string;
    answer6text: string;
    answer7text: string;
    status: string;
    timeSubmitted?: string;
    answerGuid: string;
    summary: boolean;
}

export const initParameter: IParameter = {
    guid: "",
    name: "",
    description: "",
    networkCode: NetworkCode.Unknown,
    visibility: EVisibility.Internal,
    published: false,
    timeCreated: "",
    timePublished: "",
    deadline: "",
    hidden: false,
    year: "",
    answer1text: "0 - Needs no implementation",
    answer2text: "NI-F - Not applicable",
    answer3text: "NI-A - No consideration",
    answer4text: "NI-B - TSO internal consideration",
    answer5text: "NI-C - Preliminary, shared with stakeholders, but not publicly available",
    answer6text: "NI-D - Preliminary, shared with stakeholders and publicly available",
    answer7text: "NI-E - Submitted for approval",
    status: "",
    answerGuid: "",
    summary: false,
};

export interface IParameterFilter {
    name: string;
    networkCode?: NetworkCode;
    visibility?: EVisibility;
    year?: string;
    hidden?: boolean;
}

export const initParameterFilter: IParameterFilter = {
    name: "",
};

export const networkCodeOptions = [
    { key: NetworkCode.DCC, text: "DCC", value: NetworkCode.DCC },
    { key: NetworkCode.HVDC, text: "HVDC", value: NetworkCode.HVDC },
    { key: NetworkCode.RfG, text: "RfG", value: NetworkCode.RfG },
];

export const displayNetworkCodeOption = (networkCode?: NetworkCode) => {
    if (networkCode === undefined) {
        return "";
    }
    return networkCodeOptions.find(x => x.key === networkCode)?.text;
};
